import React from 'react'
import { Input } from '../Forms'

export const InputFilter = ({
  onChange,
  value,
  width,
}: {
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  value: any
  width?: number
}) => (
  <Input
    onChange={onChange}
    value={value}
    size="sm"
    maxWidth={width}
    width={width}
  />
)
